<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div>
	<label (click)="addImage($event)" (keydown.enter)="addImage($event)" class="image-control-button" [tabIndex]="startTabIndex">
		<mat-icon title="Add image">add_a_photo</mat-icon>
	</label>
	<label (click)="removeImage($event)" (keydown.enter)="removeImage($event)" class="image-control-button" [tabIndex]="startTabIndex + 1">
		<mat-icon title="Remove image">delete</mat-icon>
	</label>
	<input type="file" name="selectImage" id="selectImage" style="display: none" />
</div>
<img *ngIf="imageLoaded" [src]="imageAsUrl" class="responsive-image" />
<mat-spinner diameter="50" *ngIf="!imageLoaded"></mat-spinner>
